import {shallowEqual, useSelector} from 'react-redux';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import {MHTextButton, MHToolTip} from '@/components/base';

import {employmentSelector, selectClinicName} from '../redux/selectors';
import {buildSupportRequestUrl} from './utils';

import styles from './supportButton.module.scss';

export const SupportButton = () => {
    const employment = useSelector(employmentSelector, shallowEqual);
    const missionControlName = useSelector(selectClinicName);

    const handleClick = () => {
        const url = buildSupportRequestUrl(employment, missionControlName);
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <MHToolTip tooltipContent="Submit a Support Ticket (opens in a new tab)">
            <MHTextButton
                btnType="secondary-positive"
                text="Support"
                startIcon={<HelpOutlineIcon className={styles.supportButtonIcon} />}
                customClassName={styles.supportButton}
                onClick={handleClick}
                type="button"
            />
        </MHToolTip>
    );
};
